(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() : typeof define === 'function' && define.amd ? define(factory) : (global = global || self, global.multeiThemes = factory());
})(this, function () {
  'use strict';
  /**
   * Do not edit directly
   * Generated on Sun, 07 Jun 2020 17:29:18 GMT
   */

  var colorBackgroundCode = "#3C493F";
  var colorBackgroundDefault = "#623CEA";
  var colorBackgroundError = "#A63446";
  var colorBackgroundInfo = "#5887FF";
  var colorBackgroundMark = "#F4FF52";
  var colorBackgroundPaperLight = "#f6f4f3";
  var colorBackgroundPaperDark = "#140C2F";
  var colorBackgroundSuccess = "#71B340";
  var colorBackgroundWarning = "#F49F0A";
  var colorBaseBlack = "#0f1108";
  var colorBaseWhite = "#f6f4f3";
  var colorBrandPrimary = "#623CEA";
  var colorBrandSecondary = "#5887FF";
  var colorFontError = "#f6f4f3";
  var colorFontInfo = "#f6f4f3";
  var colorFontMark = "#0f1108";
  var colorFontPrimary = "#f6f4f3";
  var colorFontSecondary = "#f6f4f3";
  var colorFontSuccess = "#0f1108";
  var colorFontWarning = "#0f1108";
  var fontFamilyBase = "Overpass, \"-apple-system\", BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif";

  var base = function base(_ref) {
    var _ref$palette = _ref.palette,
        paper = _ref$palette.background.paper,
        type = _ref$palette.type;
    return {
      overrides: {
        MuiCssBaseline: {
          "@global": {
            code: {
              backgroundColor: colorBackgroundCode
            },
            mark: {
              backgroundColor: colorBackgroundMark,
              color: colorFontMark
            }
          }
        }
      },
      palette: {
        background: {
          default: colorBackgroundDefault,
          paper: paper
        },
        common: {
          black: colorBaseBlack,
          white: colorBaseWhite
        },
        error: {
          main: colorBackgroundError,
          contrastText: colorFontError
        },
        info: {
          main: colorBackgroundInfo,
          contrastText: colorFontInfo
        },
        primary: {
          main: colorBrandPrimary,
          contrastText: colorFontPrimary
        },
        secondary: {
          main: colorBrandSecondary,
          contrastText: colorFontSecondary
        },
        success: {
          main: colorBackgroundSuccess,
          contrastText: colorFontSuccess
        },
        type: type,
        warning: {
          main: colorBackgroundWarning,
          contrastText: colorFontWarning
        }
      },
      typography: {
        fontFamily: fontFamilyBase
      }
    };
  };

  var dark = base({
    palette: {
      background: {
        paper: colorBackgroundPaperDark
      },
      type: "dark"
    }
  });
  var light = base({
    palette: {
      background: {
        paper: colorBackgroundPaperLight
      },
      type: "light"
    }
  });
  var index = {
    dark: dark,
    light: light
  };
  return index;
});